export default function (initialDataInteractor, personId, questionnaireInstances) {
  let person = initialDataInteractor.data.people.find(p => p.id == personId);
  if (!person.questionnaire_instances) person.questionnaire_instances = [];
  questionnaireInstances.forEach(i => person.questionnaire_instances.push(i));
}